import { Container } from "./MessagesToGroupsStyle";
import Spinner from "../../shared/Spinner/Spinner";
import api from "../../services/api";


import { IoSend } from 'react-icons/io5';
import { useEffect, useState } from "react";

import { Plugins } from '@capacitor/core';
import PageTitle from "../../components/PageTitle";
const { Modals } = Plugins;

export default function MessagesToGroups(props) {

  const [loading, setLoading] = useState(false);
  const [sendingMessage, setSendingMessage] = useState(false);
  const [messageSending, setMessageSending] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [groups, setGroups] = useState([] as any);
  const [groupsChecked, setGroupsChecked] = useState([{}] as any[]);

  useEffect(() => {
    GetGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  function GoBack() {
    props.history.goBack();
  }

  async function GetGroups() {
    try {
      setLoading(true);
      const response = await api.get(`/usersGroups`);
      if (response.data.success) {
        const groups = response.data.groups;
        setGroups(groups);
        setGroupsChecked(groups.map(group => { return { id: group.id, checked: false } }));
        setLoading(false);
      }
      else {
        setErrorMessage("Não foi possível carregar grupos!");
        setLoading(false);
      }
    }
    catch (error) {
      console.error(error);
      setErrorMessage("Não foi carregar grupos por problemas na conexão!");
      setLoading(false);
    }
  }

  async function SendMessage() {
    const confirm = await Modals.confirm({
      title: 'Enviar mensagem?',
      message: `Você tem certeza que quer enviar a mensagem para os grupos?`,
      okButtonTitle: "Sim",
      cancelButtonTitle: "Cancelar",
    });
    if (!confirm)
      return;

    try {
      setSendingMessage(true);
      ///Grupos que estão
      const groupsToSend = groupsChecked.filter(group => group.checked).map(group => group.id);

      const response = await api.post(`/messages/toGroups`, { message: messageSending, groups: groupsToSend });
      if (response.data.success) {
        setMessageSending("");
        setErrorMessage("");
        GoBack();
      }
      else
        setErrorMessage("Não foi possível enviar mensagem!");
      setSendingMessage(false);
    }
    catch (error: any) {
      if (error.response)
        console.error(error.response);
      else
        console.error(error);
      setErrorMessage("Não foi possível enviar mensagem por problemas na conexão!");
      setSendingMessage(false);
    }
  }

  function OnChangeGroupMarked(group, newValue) {
    let status = [...groupsChecked];
    const index = status.findIndex(groupStatus => groupStatus.id === group.id);
    status[index] = { id: group.id, checked: newValue };
    setGroupsChecked(status);
  }

  function OnKeyDown(e) {
    ///Enter é 13
    if (e.keyCode === 13) {
      e.preventDefault();
      SendMessage();
    }
  }

  return (
    <Container>
      <PageTitle title="Mensagem para Grupo" />
      <main>
        <section className="table-title">
          <button onClick={GoBack} className="button">Voltar</button>
          <h1>{"Mensagem para grupos"}</h1>
        </section>
        {errorMessage !== "" && <h1 className="alert"> {errorMessage}</h1>}
        <Spinner spinning={loading} />

        <div id="groups-area">
          {groups && groups.length > 0 &&
            groups.map(group => {
              return (
                <div className="group-option" key={group.id}>
                  <input
                    type="checkbox"
                    key={group.id}
                    id={group.id}
                    value={groupsChecked[group.id]}
                    onChange={e => OnChangeGroupMarked(group, e.target.checked)} />
                  <label htmlFor={group.id}>{group.groupName}</label>
                </div>
              )
            })
          }

        </div>
        <div id="input-area">
          <input
            type="text"
            id="message-input"
            autoComplete="off"
            value={messageSending}
            disabled={sendingMessage}
            onKeyDown={e => OnKeyDown(e)}
            onChange={e => setMessageSending(e.target.value)} />

          <button id="send-message"
            ///Desabilita se estiver enviando mensagem, não digitou nada ou não escolheu grupo
            disabled={sendingMessage ||
              messageSending?.length === 0 ||
              groupsChecked.every(group => group.checked === false)
            }
            onClick={e => SendMessage()}>
            <IoSend />
          </button>
        </div>
      </main>
    </Container >
  );
}